<template>
<div class="chapter">
<div class="inner_page">
<a id="page_vi"></a>
<p class="copyright3">Copyright © 2025 by Keren Eldad</p>
<p class="copyright2">Published by Mango Publishing, a division of Mango Publishing Group, Inc.</p>
<p class="copyright1">Cover Design: Lucy Giller</p>
<p class="copyright2">Cover Photo/illustration: <span class="weblink"><a href="http://stock.adobe.com" target="_blank"><span class="underline">stock.adobe.com</span></a></span></p>
<p class="copyright2">Headshot Photography: Shanaz Maharaj</p>
<p class="copyright2">Layout &amp; Design: Lucy Giller</p>
<p class="copyright1">Mango is an active supporter of authors’ rights to free speech and artistic expression in their books. The purpose of copyright is to encourage authors to produce exceptional works that enrich our culture and our open society.</p>
<p class="copyright1">Uploading or distributing photos, scans or any content from this book without prior permission is theft of the author’s intellectual property. Please honor the author’s work as you would your own. Thank you in advance for respecting our author’s rights.</p>
<p class="copyright2">For permission requests, please contact the publisher at:</p>
<p class="copyright1">Mango Publishing Group</p>
<p class="copyright2">5966 South Dixie Highway, Suite 300</p>
<p class="copyright2">Miami, FL 33143</p>
<p class="copyright2"><span class="weblink"><a href="mailto:info@mango.bz"><span class="underline">info@mango.bz</span></a></span></p>
<p class="copyright1">For special orders, quantity sales, course adoptions and corporate sales, please email the publisher at <span class="weblink"><a href="mailto:sales@mango.bz"><span class="underline">sales@mango.bz</span></a></span>. For trade and wholesale sales, please contact Ingram Publisher Services at <span class="weblink"><a href="mailto:customer.service@ingramcontent.com"><span class="underline">customer.service@ingramcontent.com</span></a></span> or +1.800.509.4887.</p>
<p class="copyright1">Gilded: Breaking Free from the Cage of Ambition, Perfectionism, and the Relentless Pursuit of More</p>
<p class="copyright1">Library of Congress Cataloging-in-Publication number: 2024947275</p>
<p class="copyright2">ISBN: (print) 978-1-68481-757-3, (ebook) 978-1-68481-758-0</p>
<p class="copyright2">BISAC category code: BUS041000, BUSINESS &amp; ECONOMICS / Management</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?82459a14